import React, { useState } from "react";
import SidePanel from "./SidePanel";
import UpdateCaseInfoModal from "./UpdateCaseInfoModal";
import CaseInfoConfirmationModal from "./CaseInfoConfirmationModal";
import DeferralListModal from "./DeferralListModal";
import MoneyReturnedToBankModal from "./MoneyReturnedToBankModal";

const DetailsSideBar = ({
  selectedPanel,
  togglePanel,
  handlePanelClick,
  stepSelected,
  handleStepClick,
  lead_id,
  sidePanelPermissions,
  changeMoneyReturnToBank,
  fetchCaseData,
  panels,
  step_details,
  sub_stage,
}) => {
  const initialState = {
    showUpdateCaseInfoModal: false,
    showDeferralListModal: false,
    showMoneyReturnToBankModal: false,
  };
  const [state, setState] = useState(initialState);

  const {
    showMoneyReturnedToBankBtn,
    showUpdateCaseInfoBtn,
    caseInfoTitle,
    showDeferralListBtn,
    checkDownloadCaseInfoPermission,
    checkUpdateCaseInfoPermission,
  } = sidePanelPermissions;

  const [openCaseConfirmModal, setOpenCaseConfirmModal] = useState(false);

  const toggleCaseConfirmModal = () =>
    setOpenCaseConfirmModal(!openCaseConfirmModal);

  step_details = [3, 4, 12, 14].includes(sub_stage)
    ? step_details?.l1
    : step_details?.l0;

  return (
    <div className="navsidebarmenu">
      {openCaseConfirmModal && (
        <CaseInfoConfirmationModal
          toggleCaseConfirmModal={toggleCaseConfirmModal}
          finance_lead_id={lead_id}
          fetchCaseDetails={fetchCaseData}
        />
      )}
      {state.showUpdateCaseInfoModal && (
        <UpdateCaseInfoModal
          title={caseInfoTitle}
          closeUpdateCaseInfoModal={() =>
            setState({ ...state, showUpdateCaseInfoModal: false })
          }
          lead_id={lead_id}
          toggleCaseConfirmModal={toggleCaseConfirmModal}
          checkDownloadCaseInfoPermission={checkDownloadCaseInfoPermission}
          checkUpdateCaseInfoPermission={checkUpdateCaseInfoPermission}
        />
      )}
      {state.showDeferralListModal && (
        <DeferralListModal
          closeDeferralListModal={() =>
            setState({ ...state, showDeferralListModal: false })
          }
          lead_id={lead_id}
        />
      )}
      {state.showMoneyReturnToBankModal && (
        <MoneyReturnedToBankModal
          changeMoneyReturnToBank={changeMoneyReturnToBank}
          closeMoneyReturnedToBankModal={() =>
            setState({ ...state, showMoneyReturnToBankModal: false })
          }
        />
      )}
      <div className="left_col scroll-view">
        <div className="side_wizard_box">
          <div
            className="accordion case-details-nav-container left-accordian-container collapse in"
            id="accordion"
            role="tablist"
            aria-multiselectable="true"
          >
            {panels.map((panel, index) => {
              return +panel.is_visible === 1 ? (
                <SidePanel
                  selectedPanel={selectedPanel}
                  togglePanel={togglePanel}
                  handlePanelClick={handlePanelClick}
                  stepSelected={stepSelected}
                  handleStepClick={handleStepClick}
                  panelId={index}
                  title={panel.title}
                  steps={panel.steps}
                  key={index}
                  step_details={step_details}
                ></SidePanel>
              ) : null;
            })}

            {showUpdateCaseInfoBtn ? (
              <div className="btn-left-wrapper" style={{ display: "block" }}>
                <button
                  style={{ width: "100%", padding: "6px" }}
                  className="font-12 btn rc-btn_primary btn-md"
                  onClick={(e) => {
                    setState({ ...state, showUpdateCaseInfoModal: true });
                    e.stopPropagation();
                  }}
                >
                  Update Case Info
                </button>
              </div>
            ) : (
              ""
            )}
            {showMoneyReturnedToBankBtn ? (
              <div className="btn-left-wrapper">
                <button
                  style={{ width: "100%" }}
                  className="btn btn-danger btn-md font-12"
                  onClick={(e) => {
                    setState({ ...state, showMoneyReturnToBankModal: true });
                    e.stopPropagation();
                  }}
                >
                  Money return to bank
                </button>
              </div>
            ) : (
              ""
            )}

            {showDeferralListBtn ? (
              <div className="btn-left-wrapper">
                <button
                  style={{ width: "100%" }}
                  className="btn btn-danger btn-md font-12"
                  onClick={(e) => {
                    setState({ ...state, showDeferralListModal: true });
                    e.stopPropagation();
                  }}
                >
                  Deferral List
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsSideBar;
